import { TerminalPanel } from '@/components/terminal/TerminalPanel'

export function HeroSection() {
  return (
    <section
      id="hero"
      aria-labelledby="hero-heading"
      className="page-snap-section flex flex-col items-center justify-center px-5 sm:px-8"
    >
      <div className="mx-auto flex w-full max-w-page flex-col items-center text-center pt-16 my-8">
        <div className="reveal flex flex-col items-center gap-8">
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-surface-container px-3 py-1">
            <span className="h-2 w-2 rounded-full bg-secondary animate-pulse-soft" />
            <span className="font-mono text-[10px] uppercase tracking-[0.34em] text-muted sm:text-[11px]">
              Online / System Available
            </span>
          </div>
          <div>
            <h1 className="font-display text-4xl font-semibold tracking-[-0.045em] text-foreground sm:text-5xl md:text-[56px] md:leading-tight">
              compute to build.
            </h1>
          </div>
          <h1 id="hero-heading" className="sr-only">
            sekaizato landing page
          </h1>
        </div>
        <div className="mt-10 w-full">
          <TerminalPanel />
        </div>
      </div>
    </section>
  )
}
